import { __assign } from "tslib";
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
import { CollapsbileToggle } from './collapsible-toggle';
import { createLegacyToggleDriver } from '../../primitives/toggle/toggle.legacy-driver';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
export var createCollapsbileToggleDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.collapsible-toggle', 'CollapsibleToggle');
    var toggleDriver = createLegacyToggleDriver(baseDriver.find('.toggle-wrapper').elem);
    return {
        getTitleText: function () { return baseDriver.find('.header-title').getText(); },
        isOn: function () { return baseDriver.elem.classList.contains('on'); },
        toggle: function () { return toggleDriver.toggle(); },
        toggleCollapsible: function () { return baseDriver.find('.header-title').click(); },
        isExpanded: function () { return baseDriver.elem.classList.contains('expanded'); },
        isDisabled: function () { return toggleDriver.isDisabled(); },
    };
};
export var createCollapsbileToggle = function (props) {
    var elem = renderAndMountComponent(React.createElement(CollapsbileToggle, __assign({}, props)));
    return createCollapsbileToggleDriver(elem);
};
//# sourceMappingURL=collapsible-toggle.driver.js.map